import { computed } from 'vue'
import type { AvatarMemberAttributes } from '../components/base/avatar/avatar-props'
import { memberFullName } from '../models/member/member-name'

const palettes = [
  'auraheilerin',
  'feuerbusch',
  'hardopfuschinti',
  'dromedar',
  'seich',
  'kunstrasen',
  'grasfroschli',
  'marsmenschli',
  'gorgonzola',
  'brienzersee',
  'bergseeli',
  'suffblaue',
  'einhornzunge',
  'waldbeeri',
  'pinkpanter',
  'bibelirot',
]

export function colorForSeed(seed: string): string {
  const full = seed.toLowerCase()
  let hash = 0
  for (let i = 0; i < full.length; i++) {
    hash = full.charCodeAt(i) + ((hash << 5) - hash)
  }
  return palettes[Math.abs(hash) % palettes.length]
}

export const useColorForMember = (member: AvatarMemberAttributes) => {
  const getColorForMember = computed(() => colorForSeed(memberFullName(member)))

  return {
    getColorForMember,
  }
}
